
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-86b97b4c&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AnchorAboutPlatForm.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AnchorAboutPlatForm.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-86b97b4c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AnchorAboutPlatForm.vue"),
  /* scopeId */
  "data-v-86b97b4c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/helpCenter/AnchorAboutPlatForm.vue
// module id = 344
// module chunks = 0